import {
  MALL_LIST_REQUEST,
  MALL_LIST_RESET,
  MALL_LIST_SUCCESS,
  MALL_LIST_FAIL,
  MALL_DELETE_REQUEST,
  MALL_DELETE_SUCCESS,
  MALL_DELETE_FAIL,
  MALL_CREATE_REQUEST,
  MALL_CREATE_SUCCESS,
  MALL_CREATE_FAIL,
  MALL_CREATE_RESET,
  MALL_EDIT_REQUEST,
  MALL_EDIT_SUCCESS,
  MALL_EDIT_FAIL,
  MALL_EDIT_RESET,
  MALL_UPDATE_REQUEST,
  MALL_UPDATE_SUCCESS,
  MALL_UPDATE_FAIL,
  MALL_UPDATE_RESET,
} from "../Constants/MallConstants";

export const mallListReducer = (
  state = { loading: false, recordItems: [] },
  action
) => {
  switch (action.type) {
    case MALL_LIST_REQUEST:
      return { loading: true, recordItems: [] };
    case MALL_LIST_RESET:
      return {};
    case MALL_LIST_SUCCESS:
      return {
        loading: false,
        pages: action.payload.pages,
        nextStartKey: action.payload.nextStartKey,
        recordItems: action.payload.items,
      };
    case MALL_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const mallDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case MALL_DELETE_REQUEST:
      return { loading: true };
    case MALL_DELETE_SUCCESS:
      return { loading: false, success: true };
    case MALL_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case MALL_LIST_RESET:
      return {};
    default:
      return state;
  }
};

export const mallCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case MALL_CREATE_REQUEST:
      return { loading: true };
    case MALL_CREATE_SUCCESS:
      console.log(action.payload);
      return { loading: false, success: true, recordItem: action.payload };
    case MALL_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case MALL_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const mallEditReducer = (state = { recordItem: undefined }, action) => {
  switch (action.type) {
    case MALL_EDIT_REQUEST:
      return { ...state, loading: true };
    case MALL_EDIT_SUCCESS:
      return { loading: false, recordItem: action.payload.item };
    case MALL_EDIT_FAIL:
      return { loading: false, error: action.payload };
    case MALL_EDIT_RESET:
      return {};
    default:
      return state;
  }
};

export const mallUpdateReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case MALL_UPDATE_REQUEST:
      return { loading: true };
    case MALL_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        recordItem: action.payload.items,
      };
    case MALL_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case MALL_UPDATE_RESET:
      return { data: {} };
    default:
      return state;
  }
};
